<template>
  <div>
    <div class="columns toolbar-box action-right">
      <div class="column is-3">
        <h1 class="title is-3 between-center">
                    <span>
                        <span>Reports list</span>
                    </span>
        </h1>
      </div>
    </div>

    <o-table
        :data="reports"
        paginated
        backend-pagination
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        backend-sorting
        @page-change="onPageChange"
        @sort="onSort">
      <o-table-column
          v-slot="props"
          field="name"
          label="Report name"
          sortable>
        {{ props.row.name }}
      </o-table-column>
      <o-table-column
          v-slot="props"
          field="url"
          label="Report url"
          numeric
          sortable>
        <router-link :to="{ name: props.row.url, params: {}}" class="button is-info">
          Go to report
        </router-link>
      </o-table-column>
    </o-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'

export default {
  mixins: [Table],

  components: {

  },

  data () {
    return {
      reports: [
        {"id": "pending-approved", "name": "Proposals by Client Comparison", "url": "reports.pending-approved", "path": "/pending-approved"},
        {"id": "referrals", "name": "Referrals", "url": "reports.referrals", "path": "/referrals"},
        {"id": "billing-summary", "name": "Billing summary", "url": "reports.billing-summary", "path": "/billing-summary"},
        {"id": "pending-change-orders", "name": "Pending change orders", "url": "reports.pending-change-orders", "path": "/pending-changer-orders"},
      ]

    }
  },

  mounted() {

  },

  methods: {

  },

  computed: {
  }
}
</script>
